import { css, Theme } from '@emotion/react';

const flexCenter = {
  X: css`
    display: flex;
    justify-content: center;
  `,
  Y: css`
    display: flex;
    align-items: center;
  `,
  XY: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};

declare module '@emotion/react' {
  export interface Theme {
    flexCenter: any;
    breakPoint: {
      desktop: string;
      tablet: string;
      mobile: string;
      mobileAndTablet: string;
    };
    color: { [key: string]: string };
  }
}

const size: { [key: string]: number } = {
  desktop: 1024,
  tablet: 768,
  mobile: 335,
};

const color: { [key: string]: string } = {
  // styled 안에서 쓰일 colorPreset
  topco_main: '#123123',
  topco_sub: '#456566',
};

const breakPoint = {
  desktop: `(min-width: ${size.desktop}px)`,
  tablet: `(min-width: ${size.tablet}px) and (max-width:${size.desktop - 1}px)`,
  mobile: `(min-width: 0) and (max-width:${size.tablet - 1}px)`,
  mobileAndTablet: `(min-width: 0) and (max-width:${size.desktop - 1}px)`,
};

const theme: Theme = {
  flexCenter,
  breakPoint,
  color,
};

export default theme;
